import { BASE_URL } from '../../general/variables';

async function getCounter(intent, id, type, leads_score = 'ALL') {
  let res;

  try {
    if (intent == 'counter') {
      res = await $.ajax({
        url: 'https://backend.icedalnusa.com/expo/api/fetch-dashboard-v2',
        type: 'POST',
        data: JSON.stringify({
          id: id,
          type: type,
          leads_score: leads_score,
        }),
        contentType: 'application/json', // tell server this is JSON
        dataType: 'json', // expect JSON back
      });
    }
  } catch (e) {
    res = {
      code: 204,
      message: e,
    };
  }

  return res;
}

function updateCardStatus(status, card) {
  if (status == 'BLOCK') {
    KTApp.block(card, {
      opacity: 0.1,
      state: 'primary',
    });
  } else if (status == 'UNBLOCK') {
    KTApp.unblock(card);
  }
}

function updateCounter(finalCount, el, callback) {
  let count = 0;
  const step = Math.ceil(finalCount / 100);

  function incrementCounter() {
    count += step;

    if (count > finalCount) {
      count = finalCount;
    }

    el.text(count.toLocaleString('id-ID'));

    if (count < finalCount) {
      setTimeout(incrementCounter, 10);
    } else {
      callback();
    }
  }

  setTimeout(incrementCounter, 10);
}

export { getCounter, updateCounter, updateCardStatus };
